/* ONE BOUT — <ob-scroll-rail> (S2/H2): native scroll-snap rail + looping prev/next + progress bar.
   Used by sections/ob-reviews.liquid (arrows 208:1374, mobile progress 333:5161) and
   sections/ob-athletes.liquid (mobile progress 333:4621).
   Markup inside the element: [data-rail-track] (the overflow-x scroller), optional [data-rail-prev] /
   [data-rail-next] buttons, optional progress bar that reads --ob-rail-size / --ob-rail-pos (set here).
   Prestige <scroll-carousel> clamps at the ends (no loop) and disables its buttons, hence this ~50-line element. */
class ObScrollRail extends HTMLElement {
  connectedCallback() {
    this.track = this.querySelector('[data-rail-track]');
    if (!this.track || this._ready) return;
    this._ready = true;
    this.querySelectorAll('[data-rail-prev]').forEach((b) => b.addEventListener('click', () => this.go(-1)));
    this.querySelectorAll('[data-rail-next]').forEach((b) => b.addEventListener('click', () => this.go(1)));
    this.track.addEventListener('scroll', () => this.update(), { passive: true });
    // theme editor: bring the selected block into view inside the rail
    this.addEventListener('shopify:block:select', (e) => {
      const cell = [...this.track.children].find((c) => c.contains(e.target));
      if (cell) this.track.scrollTo({ left: cell.offsetLeft - this.track.offsetLeft - parseFloat(getComputedStyle(this.track).scrollPaddingInlineStart || 0), behavior: e.detail && e.detail.load ? 'auto' : 'smooth' });
    });
    new ResizeObserver(() => this.update()).observe(this.track);
    this.update();
  }

  get max() { return this.track.scrollWidth - this.track.clientWidth; }

  step() {
    const cells = this.track.children;
    if (cells.length < 2) return this.track.clientWidth;
    return Math.abs(cells[1].offsetLeft - cells[0].offsetLeft) || cells[0].offsetWidth;
  }

  go(dir) {
    const t = this.track, max = this.max, x = Math.abs(t.scrollLeft);
    if (max <= 1) return;
    const rtl = getComputedStyle(t).direction === 'rtl' ? -1 : 1;
    if (dir > 0 && x >= max - 2) t.scrollTo({ left: 0, behavior: 'smooth' });              // loop → start
    else if (dir < 0 && x <= 2) t.scrollTo({ left: max * rtl, behavior: 'smooth' });       // loop → end
    else t.scrollBy({ left: dir * rtl * this.step(), behavior: 'smooth' });
  }

  update() {
    const t = this.track, max = this.max;
    const size = t.scrollWidth ? Math.min(1, t.clientWidth / t.scrollWidth) : 1;
    const pos = max > 0 ? Math.min(1, Math.abs(t.scrollLeft) / max) : 0;
    this.style.setProperty('--ob-rail-size', size.toFixed(4));
    this.style.setProperty('--ob-rail-pos', pos.toFixed(4));
    this.toggleAttribute('data-static', max <= 1);
    // a11y (FIX2): a track rendered with tabindex="0" is keyboard-focusable only while it actually scrolls
    if (t.hasAttribute('tabindex') || t.hasAttribute('data-rail-focusable')) {
      t.setAttribute('data-rail-focusable', '');
      if (max > 1) t.setAttribute('tabindex', '0'); else t.removeAttribute('tabindex');
    }
    this.querySelectorAll('[data-rail-prev],[data-rail-next]').forEach((b) => { b.disabled = max <= 1; });
  }
}

if (!customElements.get('ob-scroll-rail')) customElements.define('ob-scroll-rail', ObScrollRail);
